module.exports = __webpack_public_path__ + "img/africaunion.566464ae.png";